import { InjectionToken } from '@angular/core';

export const SERVER_PORT = new InjectionToken<string | number>('SERVER_PORT');
